var _pattern, _rect, _g, _circle, _circle2, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _pattern || (_pattern = /*#__PURE__*/React.createElement("pattern", {
    id: "grid",
    x: 0,
    y: 0,
    width: 20,
    height: 20,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 1,
    fill: "#E5EFFF",
    fillOpacity: 0.1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 400,
    fill: "url(#grid)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150 160 L190 160 L190 240 L150 240 L150 160 Z",
    fill: "#443DFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210 160 L250 160 L250 240 L210 240 L210 160 Z",
    fill: "#04A4F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 160 L310 160 L310 240 L270 240 L270 160 Z",
    fill: "#443DFF"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 120,
    stroke: "#443DFF",
    strokeWidth: 2,
    strokeOpacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 100,
    stroke: "#04A4F9",
    strokeWidth: 2,
    strokeOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 320,
    y: 160,
    width: 4,
    height: 20,
    fill: "#E5EFFF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0;1",
    dur: "1.5s",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404);
export default __webpack_public_path__ + "static/media/404.2572a56252a5bce60b21608b242bcd1c.svg";
export { ForwardRef as ReactComponent };